import { render, staticRenderFns } from "./obscured-email.vue?vue&type=template&id=2c2d7285&"
import script from "./obscured-email.vue?vue&type=script&lang=js&"
export * from "./obscured-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports